var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimePickerIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6212 0.0166016C13.1637 0.0166016 14.8662 1.80085 14.8662 4.45585V10.5834C14.8662 13.2316 13.1637 15.0166 10.6212 15.0166H4.11871C1.57621 15.0166 -0.133789 13.2316 -0.133789 10.5834V4.45585C-0.133789 1.80085 1.57621 0.0166016 4.11871 0.0166016H10.6212ZM7.10371 3.70585C6.79621 3.70585 6.54121 3.9616 6.54121 4.26835V8.0566C6.54121 8.2516 6.64621 8.4391 6.81871 8.5366L9.75871 10.2916C9.84871 10.3516 9.95371 10.3741 10.0512 10.3741C10.2387 10.3741 10.4262 10.2766 10.5312 10.0966C10.6962 9.83335 10.6062 9.48835 10.3362 9.3241L7.66621 7.7341V4.26835C7.66621 3.9616 7.41871 3.70585 7.10371 3.70585Z",
    fill: "#118BF0"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimePickerIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/time_picker_icon.a1d087ac.svg";
export { ForwardRef as ReactComponent };